<template>
  <div class="sobre-page">
    <div class="sobre-box">
      <h1 class="sobre-title">Aviso e Informações</h1>
      <div class="sobre-content">
        <ul class="sobre-list">
          <li>Este site tem <strong>finalidade exclusivamente informativa</strong>. Os dados exibidos são obtidos de fontes públicas para ajudar jogadores a consultar cotação e comparação de personagens.</li>
          <li><strong>Não há custos</strong> para o uso do site. Todo o conteúdo e funcionalidades são oferecidos gratuitamente.</li>
          <li><strong>Não guardamos dados especiais de ninguém.</strong> Não coletamos senhas, dados de conta ou informações pessoais sensíveis. O que utilizamos limita-se a informações já públicas no jogo (como nome de personagem, level, vocação, world) para exibir cotação e histórico de leilões.</li>
          <li>Trata-se de um <strong>site de fãs, não oficial</strong>, sem vínculo com os administradores do servidor. Para suporte oficial do jogo, procure os canais oficiais.</li>
          <li class="sobre-item-destaque">Se você quiser pagar um cafezinho em agradecimento, pode enviar para o personagem <strong>Gudanado</strong> no mundo <strong>Serenian I</strong>.</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.sobre-page {
  min-height: 60vh;
}

.sobre-box {
  border: 2px solid #8b6914;
  border-radius: 8px;
  background: linear-gradient(180deg, #2a2520 0%, #1c1916 100%);
  overflow: hidden;
}

.sobre-title {
  margin: 0;
  padding: 1.5rem 1.5rem;
  font-size: 1.75rem;
  font-weight: 700;
  color: #d4af37;
  letter-spacing: 0.02em;
  border-bottom: 1px solid rgba(139, 105, 20, 0.5);
}

.sobre-content {
  padding: 1.5rem 1.5rem 2rem;
  color: #e8dcc8;
}

.sobre-list {
  margin: 0;
  padding-left: 1.5rem;
  list-style: disc;
  font-size: 1.05rem;
  line-height: 1.7;
}

.sobre-list li {
  margin-bottom: 1rem;
}

.sobre-list li:last-child {
  margin-bottom: 0;
}

.sobre-list strong {
  color: #d4af37;
}

.sobre-item-destaque {
  margin-top: 2rem !important;
  padding: 1.25rem;
  background: rgba(212, 175, 55, 0.12);
  border: 1px solid rgba(139, 105, 20, 0.5);
  border-radius: 8px;
  list-style: none;
  padding-left: 1.25rem;
  font-size: 1.15rem;
}

.sobre-item-destaque strong {
  color: #f0e4b8;
}
</style>
